import React, { useState, useEffect } from "react";
import { Table, Thead, Tr, Th, Sortable } from "@lightspeed/cirrus-table";
import { Card } from "@lightspeed/flame/Card";
import Row from "./taxesTable/Row";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import * as sortFns from "../../utils/sortFn";

const TaxesTable = ({ data, scrollPos, sortState, changeSortState }) => {
  const ui = useSelector((state) => state.ui);
  const [sortedData, setSortedData] = useState([]); // Initialize with an empty array
  const sortValues = ["unsorted", "desc", "asc"];
  const reducer = (accumulator, currentValue) => accumulator + currentValue;

  // Ensure `data` is always an array
  useEffect(() => {
    if (Array.isArray(data)) {
      setSortedData([...data]);
    } else {
      console.error("TaxesTable: Expected data to be an array, but got:", data);
      setSortedData([]); // Fallback to an empty array
    }
  }, [data]);

  // Handle sorting logic
  useEffect(() => {
    if (Array.isArray(data) && sortState.reduce(reducer) > 0) {
      let newSortedData = [...data];

      // company id
      if (sortState[0] === 1) {
        newSortedData.sort(sortFns.customSortGen("company_id"));
      } else if (sortState[0] === 2) {
        newSortedData.sort(sortFns.customSortGen("company_id")).reverse();
      }

      // payment id
      if (sortState[1] === 1) {
        newSortedData.sort(sortFns.customSortGen("tax_id"));
      } else if (sortState[1] === 2) {
        newSortedData.sort(sortFns.customSortGen("tax_id")).reverse();
      }

      // tax name
      if (sortState[2] === 1) {
        newSortedData.sort(sortFns.customSortGenString("tax_name"));
      } else if (sortState[2] === 2) {
        newSortedData.sort(sortFns.customSortGenString("tax_name")).reverse();
      }

      // account id
      if (sortState[3] === 1) {
        newSortedData.sort(sortFns.customSortGenString("account_id"));
      } else if (sortState[3] === 2) {
        newSortedData.sort(sortFns.customSortGenString("account_id")).reverse();
      }

      // account description
      if (sortState[4] === 1) {
        newSortedData.sort(sortFns.customSortGenString("account_description"));
      } else if (sortState[4] === 2) {
        newSortedData
          .sort(sortFns.customSortGenString("account_description"))
          .reverse();
      }

      setSortedData(newSortedData);
    } else {
      setSortedData(Array.isArray(data) ? [...data] : []);
    }
  }, [sortState, data]);

  // Handle no search results
  if (sortedData.length === 0 && ui.search) {
    return (
      <div className="loader-no-item">
        <h3>No items match your search</h3>
      </div>
    );
  }

  // Handle loading or invalid data
  if (!Array.isArray(sortedData) || sortedData.length === 0) {
    return <Loader />;
  }

  return (
    <Card top="true">
      <Table>
        <Thead>
          {scrollPos === true ? (
            <Tr className={`${ui.theme === "flame" ? "" : "dark-table"}`}>
              <Sortable.Th
                width="15%"
                direction={sortValues[sortState[0]]}
                onClick={() => {
                  changeSortState(0);
                }}
              >
                Company
              </Sortable.Th>
              <Sortable.Th
                width="15%"
                direction={sortValues[sortState[1]]}
                onClick={() => {
                  changeSortState(1);
                }}
              >
                Tax ID
              </Sortable.Th>
              <Sortable.Th
                width="20%"
                direction={sortValues[sortState[2]]}
                onClick={() => {
                  changeSortState(2);
                }}
              >
                Tax Name
              </Sortable.Th>
              <Sortable.Th
                width="20%"
                direction={sortValues[sortState[3]]}
                onClick={() => {
                  changeSortState(3);
                }}
              >
                Account Id
              </Sortable.Th>
              <Sortable.Th
                width="20%"
                direction={sortValues[sortState[4]]}
                onClick={() => {
                  changeSortState(4);
                }}
              >
                Account Description
              </Sortable.Th>
              <Th width="10%" textAlign="right">
                Action
              </Th>
            </Tr>
          ) : (
            <Tr className={`${ui.theme === "flame" ? "" : "dark-table-fake"}`}>
              <Th className="table-th-sticky" width="15%">
                Company
              </Th>
              <Th className="table-th-sticky" width="15%">
                Tax ID
              </Th>
              <Th className="table-th-sticky" width="20%">
                Tax Name
              </Th>
              <Th className="table-th-sticky" width="20%">
                Account Id
              </Th>
              <Th className="table-th-sticky" width="20%">
                Account Description
              </Th>
              <Th className="table-th-sticky" width="10%" textAlign="right">
                Action
              </Th>
            </Tr>
          )}
        </Thead>
        <tbody className="t-body">
          {sortedData.map((item) => (
            <Row key={item.tax_id} item={item} />
          ))}
        </tbody>
      </Table>
    </Card>
  );
};

export default TaxesTable;